import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  overflow: hidden;
`;

export const TitlePage = styled.h1`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 2rem;
  font-weight: 200;
  margin-bottom: -0.7rem;
  display: flex;
  justify-content: space-between;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  div {
    @media (max-width: 770px) {
      margin-left: 3.5rem;
    }

    @media (min-width: 770px) {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }

  img {
    @media (max-width: 770px) {
      margin: 0 1rem 1rem -3rem;
    }
  }

  span {
    @media (min-width: 770px) {
      margin: 0.8rem 0 0 0.8rem;
    }
  }
`;

export const DesktopDetails = styled.div`
  @media (min-width: 500px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }
`;

export const Card = styled.div`
  background-color: white;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  margin: 1rem auto;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  max-width: 762px;
  box-shadow: 0px 6px 12px #00000066;

  @media (max-width: 700px) {
    margin: 1rem 0.8rem 0 0.8rem;
    height: auto;
    min-height: 85vh;
  }

  @media (max-width: 700px) and (min-height: 795px) {
    min-height: 90vh;
  }

  @media (min-width: 768px) {
    border-radius: 0.5rem;
  }
`;

export const TitleCard = styled.h4`
  color: #487cf5;
  font-size: 1rem;
  font-weight: 600;
`;

export const Order = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;
  margin: 1rem 2rem;
  padding: 0 1rem;

  @media (min-width: 500px) {
    margin: 1rem 0 2rem 2rem;
    padding: 0 1.5rem;
  }

  h4 {
    color: #487cf5;
    text-align: center;
    font-size: 1.2rem;
    margin: 0.3rem;
    font-weight: 550;
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: -0.4rem;

  p {
    color: #868686;
    font-size: 0.8rem;
  }
`;

export const TextStatus = styled.span`
  color: #808080;
  font-size: 0.8rem;
  font-weight: 500;
`;

export const DesktopGridDetails = styled.div`
  @media (min-width: 500px) {
    display: flex;
    justify-content: space-between;
    margin-right: 2rem;
  }
`;

export const CloseIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 28px;
    height: 28px;
    margin-top: 19px;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;
  @media (max-width: 770px) {
    padding: 0;
  }
`;

export const StatusCollorContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FlexAlign = styled.div`
  display: flex;
  align-content: center;
  justify-content: space-between;

  @media(min-width: 500px) {
    margin-right: 7rem;
  }

  span {
    color: #000FFF;
  }
`;
